import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/project-on-board/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { drapcodeIcon } from '../../common/custom/icon-library';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import CustomLoader from '../common/CustomLoader';
import ParentContentCard from '../common/ParentContentCard';

export class XanoCollection extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    developerKey: '',
    tokenError: '',
  };

  handleDeveloperKeyChange = (event) => {
    this.setState({ developerKey: event.target.value });
  };
  handleSubmit = async () => {
    console.log("props onbording", this.props)
    const { developerKey } = this.state;
    const { projectOnBoard, projectId, history, actions, version } = this.props;



    if (!developerKey) {
      this.setState({ tokenError: 'This Field is required' });
    }
    try {
      const xanoResult = await actions.getXanoSchema({ developerKey });
      if (projectOnBoard.xanoData) {
        history.push(`/2.0/project-on-board/${version}/v/${projectId}/xano-projectslist`, {
          xanoData: projectOnBoard.xanoData,
          token: developerKey,
        });
      }
    } catch (error) {
      console.error('API call error:', error);
    }
  };

  render() {
    const { getXanoSchemaPending } = this.props.projectOnBoard;

    return (

      <ParentContentCard title="Create Collection via XANO" icon="collection">

        <h4 className="ml-4">
          <b>Xano API Key</b>
        </h4>

        <CustomInputWithIcon icon="API KEY" title="API KEY">
          <input
            id="XanoAPIKey"
            name="XanoAPIKey"
            type="text"
            className="form-control form-control-sm"
            onChange={this.handleDeveloperKeyChange}
            value={this.state.developerKey}
            placeholder="Xano API key"
          />
          {this.state.tokenError && <p className="text-danger">{this.state.tokenError}</p>}
        </CustomInputWithIcon>

        <div className="text-right ml-3">
          <button
            className="btn btn-theme-submit mt-3"
            onClick={this.handleSubmit}
            disabled={getXanoSchemaPending}
          >
            <i className="wb webconnect-rocket"></i>
            &nbsp;Continue&nbsp;
            <CustomLoader loading={getXanoSchemaPending}></CustomLoader>
          </button>
        </div>
        {/* </div> */}
      </ParentContentCard>


    );
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XanoCollection);
